import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";
import { infoFecthCicloI, makeCiclo } from "dtos/ciclo";

export const getCiclo = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFecthCicloI>
  >({
    method: "GET",
    uri: ENDPOINTS.CICLO,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeCiclo(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postCiclo = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFecthCicloI>({
    method: "POST",
    uri: ENDPOINTS.CICLO,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeCiclo(response);
};

export const putCiclo = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFecthCicloI>({
    method: "PUT",
    uri: ENDPOINTS.CICLO,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeCiclo(response);
};

export const deleteCiclo = async (id: any) => {
  const response = await sendRequest<infoFecthCicloI>({
    method: "DELETE",
    uri: ENDPOINTS.CICLO + "/" + id,
  });
  return makeCiclo(response);
};
